module.exports = __webpack_public_path__ + "static/media/hiking-trails.6fbc4e92.png";